(function () {
    new themegoal.helpers.Responsive();
    new TG_ProductCardColorSwatch();

    let windowWidth = window.innerWidth;

    window.addEventListener('resize', function () {
        let newWidth = window.innerWidth;

        if (newWidth === windowWidth) {
            return;
        }

        windowWidth = newWidth;

        let headerSection = document.getElementById('Header');

        if (headerSection) {
            document.documentElement.style.setProperty('--tg-header-height', headerSection.offsetHeight + 'px');
            document.documentElement.style.setProperty('--tg-header-logo-width', document.querySelector('.Header__LogoWrapper').offsetWidth + 'px');
        }
    });

})();

(function () {
  if (window.__benlarkyCartCookieFlow) return;
  window.__benlarkyCartCookieFlow = true;

  const placements = new Map();
  const preparedPreferences = new WeakSet();
  let host = null;
  let hostOwner = null;
  let scheduled = false;

  function displayed(element) {
    return Boolean(element && element.isConnected && getComputedStyle(element).display !== 'none');
  }

  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(sync);
  }

  function preserveFocus(node, move) {
    const focused = document.activeElement;
    const containsFocus = focused && node.contains(focused);
    move();
    if (containsFocus && focused.isConnected && displayed(focused)) {
      focused.focus({ preventScroll: true });
    }
  }

  function moveIntoHost(node) {
    if (!node || node.parentNode === host) return;
    if (!placements.has(node)) {
      const placeholder = document.createComment('Benlarky cookie placement');
      node.parentNode.insertBefore(placeholder, node);
      placements.set(node, placeholder);
    }
    preserveFocus(node, function () { host.appendChild(node); });
  }

  function restore() {
    if (!host) return;
    const focused = document.activeElement;
    const lostFocus = host.contains(focused);
    const preferences = host.querySelector('#shopify-pc__prefs');
    const banner = host.querySelector('#shopify-pc__banner');
    if (preferences && !placements.has(preferences)) placements.set(preferences, null);
    placements.forEach(function (placeholder, node) {
      if (host.contains(node)) {
        preserveFocus(node, function () {
          if (placeholder && placeholder.isConnected) {
            placeholder.replaceWith(node);
          } else if (node.id === 'shopify-pc__prefs' && banner && banner.isConnected && banner.parentNode !== host) {
            banner.insertAdjacentElement('afterend', node);
          } else {
            document.body.appendChild(node);
          }
        });
      }
      if (placeholder && placeholder.isConnected) placeholder.remove();
    });
    placements.clear();
    const previousOwner = hostOwner;
    host.remove();
    host = null;
    hostOwner = null;
    if (previousOwner) previousOwner.classList.remove('bl-cart-consent-inline');
    if (lostFocus && previousOwner && previousOwner.id === 'CartDrawer' && previousOwner.classList.contains('Show')) {
      const current = document.activeElement;
      if (!current || !previousOwner.contains(current) || !displayed(current)) {
        const close = previousOwner.querySelector('[data-tg-dismiss="Drawer"]');
        if (close) close.focus({ preventScroll: true });
      }
    }
  }

  function preparePreferences(preferences) {
    if (!preferences || preparedPreferences.has(preferences)) return;
    preparedPreferences.add(preferences);
    preferences.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') event.stopPropagation();
    });
  }

  function sync() {
    scheduled = false;
    const drawer = document.getElementById('CartDrawer');
    const drawerOpen = Boolean(drawer && drawer.classList.contains('Show'));
    const cartPage = document.body.classList.contains('Template--cart');
    const main = cartPage ? document.querySelector('main#MainContent') : null;
    const owner = drawerOpen ? drawer : main;
    const banner = document.getElementById('shopify-pc__banner');
    const preferences = document.getElementById('shopify-pc__prefs');
    preparePreferences(preferences);

    if (host && (hostOwner !== owner || !host.isConnected)) restore();
    if (owner && (displayed(banner) || displayed(preferences))) {
      if (!host) {
        host = document.createElement('div');
        host.className = 'bl-cart-consent-host';
        hostOwner = owner;
        const form = owner.id === 'CartDrawer' ? owner.querySelector('.Form--cart') : null;
        if (form) form.insertAdjacentElement('afterend', host);
        else owner.appendChild(host);
        owner.classList.add('bl-cart-consent-inline');
      }
      moveIntoHost(banner);
      moveIntoHost(preferences);
    } else {
      restore();
    }

    if ((drawerOpen || displayed(preferences)) && document.body.style.overflow !== 'hidden') {
      document.body.style.setProperty('overflow', 'hidden');
    }
  }

  function relevantNode(node) {
    if (node.nodeType !== 1) return false;
    return node.matches('#CartDrawer, #shopify-pc__banner, #shopify-pc__prefs') ||
      Boolean(node.querySelector('#CartDrawer, #shopify-pc__banner, #shopify-pc__prefs'));
  }

  function start() {
    ['show.tg.Drawer', 'shown.tg.Drawer', 'hide.tg.Drawer', 'hidden.tg.Drawer', 'visitorConsentCollected'].forEach(function (name) {
      document.addEventListener(name, schedule);
    });
    new MutationObserver(function (records) {
      const changed = records.some(function (record) {
        if (record.type === 'attributes') {
          return record.target.id === 'CartDrawer' || record.target.id === 'shopify-pc__banner' || record.target.id === 'shopify-pc__prefs';
        }
        return Array.from(record.addedNodes).some(relevantNode) || Array.from(record.removedNodes).some(relevantNode);
      });
      if (changed) schedule();
    }).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'style', 'aria-hidden'] });
    sync();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
